import React from 'react';

import {StreamBankLink} from "../../../Components/Common/StreamBankLink";

import {service as ContactService} from "../../../Services/ContactService";
import {useFetchContact} from "../../../Hooks/ContactHooks";

export const ContactLink = props => {
    const {
        contact:contactFromProps = null,
        contactId,
        useShortName = null,
        defaultTitle = '',
        children = null,
    } = props;
    
    const contact = useFetchContact(contactId, contactFromProps);
    
    const title = useShortName ?
        ContactService.GetShortTitle(contact, defaultTitle) :
        ContactService.GetTitle(contact, defaultTitle);
    
    const toolUrl = "contacts" + "/" + contactId;

    return <StreamBankLink className="sb-context-node-link" Tool={toolUrl}>{children ?? title}</StreamBankLink>;
};
